import type { IInitConfig } from '@flagsmith/flagsmith'

const { REACT_APP_FLAGSMITH_ENVIRONMENT_ID, REACT_APP_FLAGSMITH_API_URL } =
  process.env

const FLAGSMITH_API_URL_PADRAO = 'https://flagsmith.digix.com.br/api/v1/'

interface FlagsmithConfig {
  environmentID: string
  apiUrl: string
  isEnabled: boolean
  initOptions: IInitConfig
}

export const flagsmithConfig: FlagsmithConfig = {
  environmentID: REACT_APP_FLAGSMITH_ENVIRONMENT_ID ?? '',
  apiUrl: REACT_APP_FLAGSMITH_API_URL ?? FLAGSMITH_API_URL_PADRAO,
  isEnabled: Boolean(REACT_APP_FLAGSMITH_ENVIRONMENT_ID),
  initOptions: {
    environmentID: REACT_APP_FLAGSMITH_ENVIRONMENT_ID ?? '',
    api: REACT_APP_FLAGSMITH_API_URL ?? FLAGSMITH_API_URL_PADRAO,
    cacheFlags: process.env.REACT_APP_NODE_ENV === 'production',
    enableAnalytics: process.env.REACT_APP_NODE_ENV === 'production',
  },
}
